import data from "../constants/pet-breed/all-breeds.json"
import boatData from "../constants/boats/index.json"
import { urlifyComplexName, urlifyName } from "../constants/stateCityDictionary"

export const getBreedUrl = (breed: string): string => {
  const dogBreeds = [...data.breeds.dogs]
  const catBreeds = [...data.breeds.cats]
  if (dogBreeds.includes(breed)) {
    return `/dog-shipping/${urlifyName(breed)}`
  }
  if (catBreeds.includes(breed)) {
    return `/cat-transportation/${urlifyName(breed)}`
  }
  return ""
}

export const getBreedLink = (breed?: string) => {
  if (!breed) return null
  if (breed.toLowerCase().includes("cat")) return null
  return getBreedUrl(breed) || null
}

export const getBoatLink = (location: string) => {
  if (!location) return null
  const formatLocation = location.split(",")

  const boat = boatData.find((item) =>
    item.city.toLowerCase().includes(formatLocation[0].toLowerCase()),
  )
  if (boat) {
    return `/boat-transportation/${urlifyComplexName(
      boat.state.toLowerCase(),
    )}/${urlifyComplexName(boat.city.toLowerCase())}`
  }
  return null
}
